import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '認識學會', href: '/about' },
  { label: '推廣行動', href: '/initiatives' },
  { label: '活動與課程', href: '/events' },
  { label: '成果與專欄', href: '/stories' },
];

const supportLinks = [
  { label: '加入會員', href: '/support/member' },
  { label: '志工參與', href: '/support/volunteer' },
  { label: '捐款支持', href: '/support/donate' },
  { label: '合作提案', href: '/cooperate' },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="mx-auto px-5 md:px-8 lg:px-12 max-w-content">
        {/* Main Footer */}
        <div className="py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <img
                src="https://tflea2015.org/wp-content/uploads/2025/06/%E5%AE%B6%E5%AD%B8%E6%9C%83LOGO_-2.png"
                alt="台灣家庭生命教育交流推廣學會"
                className="h-12 w-auto object-contain"
                width="300"
                height="93"
              />
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              以家庭為起點，串聯家長、教育者、社區與企業的家庭生命教育推廣平台。
            </p>
          </div>

          {/* Quick Nav */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">快速導覽</h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">參與與支持</h4>
            <ul className="space-y-2.5">
              {supportLinks.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">聯絡資訊</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 flex-shrink-0">
                  <i className="ri-phone-line text-sm" />
                </span>
                <a href="tel:+886-4-2535-5297" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  04-2535-5297
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 flex-shrink-0">
                  <i className="ri-mail-line text-sm" />
                </span>
                <span className="text-sm text-foreground-500">待業主提供</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-sm" />
                </span>
                <span className="text-sm text-foreground-500">待業主提供</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 flex-shrink-0">
                  <i className="ri-time-line text-sm" />
                </span>
                <span className="text-sm text-foreground-500">待業主提供</span>
              </li>
              <li className="flex items-start gap-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-primary-500 mt-0.5 flex-shrink-0">
                  <i className="ri-facebook-circle-line text-sm" />
                </span>
                <a
                  href="https://m.me/share/1ERmdhWEP9/?mibextid=wwXIfr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-primary-600 hover:text-primary-700 transition-colors"
                >
                  Facebook Messenger
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="border-t border-background-200/70 bg-background-50">
        <div className="mx-auto px-5 md:px-8 lg:px-12 max-w-content py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            版權所有 © {new Date().getFullYear()} 台灣家庭生命教育交流推廣學會
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors">
              隱私權政策
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}